import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { groupsApi } from '@/shared/redux/api/assets/groups/groups-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateGroupTags = () => {
  const dispatch = useAppDispatch();

  const invalidateGroupTags = (
    operationType: TAssetOperationTypeEnum,
    parentGroupId?: string,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          groupsApi.util.invalidateTags([
            { type: 'Groups', id: 'LIST' },
            { type: 'Groups', id: parentGroupId },
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(groupsApi.util.invalidateTags(['Groups']));
        break;
    }
  };

  return {
    invalidateGroupTags,
  };
};
